import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { PaginatorComponent } from "./paginator.component";

@NgModule({
  declarations: [PaginatorComponent],
  imports: [CoreModule],
  exports: [PaginatorComponent],
})
export class PaginatorModule {}
